var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    { attrs: { tag: "w-container" } },
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            [
              _c(
                "w-card",
                [
                  _c("w-card-title", [
                    _vm._v(_vm._s(_vm.$ct("sale/purchase"))),
                  ]),
                  _c(
                    "w-list",
                    [
                      _c(
                        "w-list-item",
                        { attrs: { to: "/settings/common/" } },
                        [
                          _c(
                            "w-list-item-icon",
                            [_c("w-fa", { attrs: { icon: "cogs" } })],
                            1
                          ),
                          _c("w-list-item-text", [
                            _vm._v(" " + _vm._s(_vm.$ct("common")) + " "),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "w-list-item",
                        {
                          attrs: {
                            to: "/settings/sell-categories/",
                            disabled: !_vm.isAdmin,
                          },
                        },
                        [
                          _c(
                            "w-list-item-icon",
                            [_c("w-fa", { attrs: { icon: "tags" } })],
                            1
                          ),
                          _c("w-list-item-text", [
                            _vm._v(
                              " " + _vm._s(_vm.$ct("sell-categories")) + " "
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "w-list-item",
                        {
                          attrs: {
                            to: "/settings/price-rules/",
                            disabled: !_vm.isAdmin,
                          },
                        },
                        [
                          _c(
                            "w-list-item-icon",
                            [_c("w-fa", { attrs: { icon: "user-tag" } })],
                            1
                          ),
                          _c("w-list-item-text", [
                            _vm._v(" " + _vm._s(_vm.$ct("price-rules")) + " "),
                          ]),
                        ],
                        1
                      ),
                      _vm.hasModule(_vm.MODULE.WINKELMODULE)
                        ? _c(
                            "w-list-item",
                            {
                              attrs: {
                                to: "/settings/loyalty-card/",
                                disabled: !_vm.isAdmin,
                              },
                            },
                            [
                              _c(
                                "w-list-item-icon",
                                [_c("w-fa", { attrs: { icon: "id-card" } })],
                                1
                              ),
                              _c("w-list-item-text", [
                                _vm._v(
                                  " " + _vm._s(_vm.$ct("loyalty-card")) + " "
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "w-list-item",
                        {
                          attrs: {
                            to: "/settings/decimals/",
                            disabled: !_vm.isAdmin,
                          },
                        },
                        [
                          _c(
                            "w-list-item-icon",
                            [_c("w-fa", { attrs: { icon: "calculator" } })],
                            1
                          ),
                          _c("w-list-item-text", [
                            _vm._v(" " + _vm._s(_vm.$ct("decimals")) + " "),
                          ]),
                        ],
                        1
                      ),
                      _vm.$wf.isLgUp
                        ? _c(
                            "w-list-item",
                            {
                              attrs: {
                                to: "/settings/sale-layouts/",
                                disabled: !_vm.isAdmin,
                              },
                            },
                            [
                              _c(
                                "w-list-item-icon",
                                [
                                  _c("w-fa", {
                                    attrs: { icon: "file-invoice-dollar" },
                                  }),
                                ],
                                1
                              ),
                              _c("w-list-item-text", [
                                _vm._v(" " + _vm._s(_vm.$ct("layouts")) + " "),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "w-list-item",
                        {
                          attrs: {
                            to: "/settings/sales/types",
                            disabled: !_vm.isAdmin,
                          },
                        },
                        [
                          _c(
                            "w-list-item-icon",
                            [_c("w-fa", { attrs: { icon: "file-invoice" } })],
                            1
                          ),
                          _c("w-list-item-text", [
                            _vm._v(" " + _vm._s(_vm.$ct("per-type")) + " "),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "w-list-item",
                        {
                          attrs: {
                            to: "/settings/sales/mails/",
                            disabled: !_vm.isAdmin,
                          },
                        },
                        [
                          _c(
                            "w-list-item-icon",
                            [_c("w-fa", { attrs: { icon: "envelope" } })],
                            1
                          ),
                          _c("w-list-item-text", [
                            _vm._v(" " + _vm._s(_vm.$ct("mails")) + " "),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "w-list-item",
                        {
                          attrs: {
                            to: "/settings/sales/client-portal/",
                            disabled: !_vm.isAdmin,
                          },
                        },
                        [
                          _c(
                            "w-list-item-icon",
                            [_c("w-fa", { attrs: { icon: "portrait" } })],
                            1
                          ),
                          _c("w-list-item-text", [
                            _vm._v(
                              " " + _vm._s(_vm.$ct("client-portal")) + " "
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "w-list-item",
                        {
                          attrs: {
                            to: "/settings/sales/vats",
                            disabled: !_vm.isAdmin,
                          },
                        },
                        [
                          _c(
                            "w-list-item-icon",
                            [_c("w-fa", { attrs: { icon: "percentage" } })],
                            1
                          ),
                          _c("w-list-item-text", [
                            _vm._v(
                              " " + _vm._s(_vm.$ct("vat-percentages")) + " "
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "w-list-item",
                        {
                          attrs: {
                            to: "/settings/sales/taxes",
                            disabled:
                              !_vm.isAdmin ||
                              !_vm.hasModule(_vm.MODULE.TAKSENVERWERKING),
                          },
                        },
                        [
                          _c(
                            "w-list-item-icon",
                            [_c("w-fa", { attrs: { icon: "coins" } })],
                            1
                          ),
                          _c("w-list-item-text", [
                            _vm._v(" " + _vm._s(_vm.$ct("taxes")) + " "),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "w-list-item",
                        {
                          attrs: {
                            to: "/settings/sales/valuta",
                            disabled:
                              !_vm.isAdmin ||
                              !_vm.hasModule(_vm.MODULE.MULTIVALUTA),
                          },
                        },
                        [
                          _c(
                            "w-list-item-icon",
                            [_c("w-fa", { attrs: { icon: "dollar-sign" } })],
                            1
                          ),
                          _c("w-list-item-text", [
                            _vm._v(" " + _vm._s(_vm.$ct("multivaluta")) + " "),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "w-list-item",
                        {
                          attrs: {
                            to: "/settings/sales/sale-edit-highlights",
                            disabled: !_vm.isAdmin,
                          },
                        },
                        [
                          _c(
                            "w-list-item-icon",
                            [_c("w-fa", { attrs: { icon: "highlighter" } })],
                            1
                          ),
                          _c("w-list-item-text", [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$ct("sale-edit-highlights")) +
                                " "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }